import Vue from 'vue'
import axios from 'axios';
import { message } from 'ant-design-vue';
Vue.use(message);

axios.defaults.baseURL = process.env.VUE_APP_BASEURL || '';
axios.defaults.timeout = 15000;
axios.interceptors.request.use(
  config => {
    const token = window.sessionStorage.getItem('token');
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  }
);
axios.interceptors.response.use(
  res => {
    return res.data;
  }, err => {
    if (err.response.data.code && err.response.data.code.toString().length > 4) {
      message.error(`${err.response.data.code}-请求失败`)
    } else {
      switch (err.response.data.code) {
        case 1000: message.error('账号已到期，请联系客服')
          break;
        case 1001: message.error('暂无权限，需要系统管理员扫码')
          break;
        case 1002: message.error('登录授权失败')
          break;
        case 1003: message.error('数据正在同步中，请稍后再试')
          break;
        case 1004: message.error('已被使用，无法删除')
          break;
        case 8011: message.error('该分类下有素材未删除')
          break;
        case 8012: message.error('该分类下有子分类未删除')
          break;
      }
    }
    return err.response.data;
  }
);

export default {
  // 首页数据
  getChart(config) {
    return axios.get('/dashboard/charts', { params: config });
  },
  getCount(config) {
    return axios.get('/dashboard/count', { params: config });
  },
  // 授权安装相关
  postAuthUrl(data) {
    return axios.post(`${process.env.VUE_APP_AUTHURL}/auth/url`, data);
  },
  postAuthSession(data) {
    return axios.post(`${process.env.VUE_APP_AUTHURL}/auth/session`, data);
  },
  postAuthCode(data) {
    return axios.post(`${process.env.VUE_APP_AUTHURL}/auth/code`, data);
  },
  // 注册相关
  postRegisterCode(data) {
    return axios.post(`${process.env.VUE_APP_AUTHURL}/auth/register`, data);
  },
  // 登录相关
  getLogin(config) {
    return axios.get('/login', { params: config });
  },
  postLogin(data) {
    return axios.post('/login', data);
  },
  // 系统配置相关
  getSetting(config) {
    return axios.get('/setting/get', { params: config });
  },
  postSetting(data) {
    return axios.post('/setting/update', data);
  },
  getSettingCheck(config) {
    return axios.get('/setting/check', { params: config });
  },
  // 通讯录相关
  postConfigSDK(data) {
    return axios.post('/config/jssdk', data);
  },
  getDepartment(config) {
    return axios.get('/department/list', { params: config });
  },
  getDepartmentSearch(config) {
    return axios.get('/department/search', { params: config });
  },
  // 客户管理相关
  getContact(config) {
    return axios.get('/contact/list', { params: config });
  },
  postContactSearch(data) {
    return axios.post('/contact/search', data);
  },
  postContactSync(data) {
    return axios.post('/contact/sync', data);
  },
  getLostContact(config) {
    return axios.get('/contact/deleted/list', { params: config });
  },
  postLostContactSearch(data) {
    return axios.post('/contact/deleted/search', data);
  },
  postAddTag(data) {
    return axios.post('/contact/add/tag', data);
  },
  getTag(config) {
    return axios.get('/tag/list', { params: config });
  },
  postTag(data) {
    return axios.post('/tag/create', data);
  },
  updateTag(data) {
    return axios.post('/tag/update', data);
  },
  delTag(data) {
    return axios.post('/tag/delete', data);
  },
  getGroup(config) {
    return axios.get('/group/list', { params: config });
  },
  postGroupSearch(data) {
    return axios.post('/group/search', data);
  },
  postGroupSync(data) {
    return axios.post('/group/sync', data);
  },
  getGroupDetail(config) {
    return axios.get('/group/get', { params: config });
  },
  // 素材相关
  getCategory(config) {
    return axios.get('/material/category/list', { params: config });
  },
  postCategory(data) {
    return axios.post('/material/category/create', data);
  },
  updateCategory(data) {
    return axios.post('/material/category/update', data);
  },
  delCategory(config) {
    return axios.get('/material/category/delete', { params: config });
  },
  getMaterial(config) {
    return axios.get('/material/list', { params: config });
  },
  getMaterialDetail(config) {
    return axios.get('/material/get', { params: config });
  },
  postMaterial(data) {
    return axios.post('/material/create', data);
  },
  updateMaterial(data) {
    return axios.post('/material/update', data);
  },
  delMaterial(config) {
    return axios.get('/material/delete', { params: config });
  },
  uploadMaterial(data) {
    return axios.post('/material/upload', data);
  },
  uploadMaterialCover(data) {
    return axios.post('/material/upload_cover', data);
  },
  // 获取欢迎语
  getWelcomeList(config) {
    return axios.get('/welcome/list', { params: config });
  },
  createWelcome(data) {
    return axios.post('/welcome/create', data);
  },
  delWelcome(config) {
    return axios.get('/welcome/delete', { params: config });
  },
  getWelcomeDetail(config) {
    return axios.get('/welcome/get', { params: config });
  },
  updateWelcome(data) {
    return axios.post('/welcome/update', data);
  },
  // 员工码相关
  getStaffQcode(config) {
    return axios.get('/qrcode/list', { params: config });
  },
  delStaff(config) {
    return axios.get('/qrcode/delete', { params: config });
  },
  createStaff(data) {
    return axios.post('/qrcode/create', data);
  },
  updateStaff(data) {
    return axios.post('/qrcode/update', data);
  },
  getStaffDetail(config) {
    return axios.get('/qrcode/get', { params: config });
  },
  downLoadCode(config) {
    return axios.get('/qrcode/download', {
      params: config,
      responseType: 'arraybuffer'
    });
  },
  // 企业群发
  sendMessage(data) {
    return axios.post('/message/send', data);
  },
  sendMessageRes(data) {
    return axios.post('/message/send/result', data);
  },
  getMessageList(data) {
    return axios.post('/message/list', data);
  },
  // 客户群码
  getGroupQrcodeList(config) {
    return axios.get('/group_qrcode/list', { params: config });
  },
  getGroupQrcodeDetail(config) {
    return axios.get('/group_qrcode/get', { params: config });
  },
  createGroupQrcode(data) {
    return axios.post('/group_qrcode/create', data);
  },
  getSign(config) {
    return axios.get('/group_qrcode/sign', { params: config });
  },
  updateGroupQrcode(data) {
    return axios.post('/group_qrcode/update', data);
  },
  deleteGroupQrcode(data) {
    return axios.post('/group_qrcode/delete', data);
  },
  getEnterCrodeList(config) {
    return axios.get('/enter_qrcode/list', { params: config });
  },
  createEnterCrode(data) {
    return axios.post('/enter_qrcode/create', data);
  },
  updateEnterCrode(data) {
    return axios.post('/enter_qrcode/update', data);
  },
  deleteEnterCrode(data) {
    return axios.post('/enter_qrcode/delete', data);
  },
  // 拉群工具
  getGroupToolList(config) {
    return axios.get('/group_tool/list', { params: config });
  },
  getGroupToolDetail(config) {
    return axios.get('/group_tool/get', { params: config });
  },
  getGroupToolQrcode(config) {
    return axios.get('/group_tool/download', { params: config, responseType: 'arraybuffer' });
  },
  postGroupTool(data) {
    return axios.post('/group_tool/create', data);
  },
  updateGroupTool(data) {
    return axios.post('/group_tool/update', data);
  },
  delGroupTool(config) {
    return axios.get('/group_tool/delete', { params: config });
  },
}
